import { render } from "./BankAccountHeadCreate.vue?vue&type=template&id=355a6b30"
import script from "./BankAccountHeadCreate.vue?vue&type=script&lang=js"
export * from "./BankAccountHeadCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__